import { useEffect } from 'react';
import { createPortal } from 'react-dom';

// Form di modifica aperto come finestra sopra la pagina, nel punto in cui si è: niente salto in cima
// (12/10/2026, titolare). attiva=false → il contenuto resta in linea (es. form "nuovo" già in alto).
// Si chiude con Esc o col suo bottone: il click fuori no (30/10/2026, titolare: si perdeva il lavoro).
export default function InFinestra({ attiva, onChiudi, children, larghezza = 820 }) {
  useEffect(() => {
    if (!attiva) return;
    const esc = e => { if (e.key === 'Escape') onChiudi(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [attiva, onChiudi]);
  if (!attiva) return children;
  return createPortal(
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.35)', zIndex: 2000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '8vh 12px', overflowY: 'auto' }}>
      <div className="pagina-entra" style={{ width: '100%', maxWidth: larghezza + 'px', boxShadow: '0 20px 60px rgba(0,0,0,.25)', borderRadius: '12px', background: 'var(--bg-card,#fff)' }}>{children}</div>
    </div>,
    document.body
  );
}
